import { createFileRoute } from '@tanstack/react-router';
import { LineSettingsPage } from '@/features/messaging/pages/line-settings-page';

export const Route = createFileRoute('/_app/settings/line')({ component: LineSettingsPage });
